import React from "react";

import {
  Grid,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetReaderSerialsQuery } from "../../../redux/api/readerTypeApis";
import CommonDialog from "../../../components/Dialog/CommonDialog";
import { ComponentSize } from "../../../utils/enum/enum";
import { ReaderApplicationData } from "./classes";
import DevicesTable from "./DevicesTable";

type InstanceStatusDialogueType = {
  isOpen: boolean;
  handleCloseDialog: () => void;
  id: string;
};

const StyledWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));
export default function Devices({
  isOpen,
  handleCloseDialog,
  id,
}: InstanceStatusDialogueType) {
  const { data: readerSerials } = useGetReaderSerialsQuery(id);
  const handleCopy = (serial: string) => {
    navigator.clipboard.writeText(serial);
  };
  const getReaderDeviceAppData = (): Array<ReaderApplicationData> => {
    // Create the return data structure
    const readerDeviceAppData: Array<ReaderApplicationData> = [];
    readerSerials?.results.forEach(entry => {
      // Case there is no application/heartbeat data
      if (entry.applications.length === 0) {
        readerDeviceAppData.push(new ReaderApplicationData(
          entry.serial_number,
          entry.last_process_list,
          '-',
          '-'
        ));
      } else {
        // Create new row for every application
        entry.applications.forEach(app => {
          readerDeviceAppData.push(new ReaderApplicationData(
            entry.serial_number,
            entry.last_process_list,
            app.name,
            app.version
          ))
        });
      };
    });
    return readerDeviceAppData;
  };
  return (
    <CommonDialog isOpen={isOpen} onClose={handleCloseDialog} title="Connected devices" size={ComponentSize.Lg}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ mt: 1 }} variant="h6">
            Total Devices count: {readerSerials?.results?.length}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <StyledWrapper>
            {DevicesTable(getReaderDeviceAppData(), handleCopy)}
          </StyledWrapper>
        </Grid>
        <Grid item xs={12}>
          {readerSerials && readerSerials?.results?.length <= 0 && (
            <Typography sx={{ mt: 1, mb: 1 }} variant="h6">
              No Devices connected to this Instance.
            </Typography>
          )}
        </Grid>
      </Grid>
    </CommonDialog>
  );
}
